import React, { useEffect } from "react";
import "./Term.css";

const termsData = [
  {
    title: "Acceptance of Terms",
    content:
      "By using MZR Software services, you agree to comply with our Terms and Conditions.",
  },
  {
    title: "Services Provided",
    content:
      "We provide custom software, ERP, POS, mobile apps, and cloud solutions as per agreed scope.",
  },
  {
    title: "Payment Terms",
    content:
      "Payments may be advance, milestone-based, or subscription-based depending on the agreement.",
  },
  {
    title: "Intellectual Property",
    content:
      "After full payment, clients receive ownership of the final solution unless otherwise stated.",
  },
  {
    title: "Confidentiality",
    content:
      "All client data and business information remains strictly confidential.",
  },
  {
    title: "Limitation of Liability",
    content:
      "MZR Software is not liable for indirect or incidental damages from software usage.",
  },
  {
    title: "Termination",
    content:
      "Either party may terminate the agreement under mutually agreed conditions.",
  },
  {
    title: "Updates",
    content: "We reserve the right to update these terms at any time.",
  },
];

function Terms() {
  useEffect(() => {
    const cards = document.querySelectorAll(".small-term-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.2 },
    );

    cards.forEach((card) => observer.observe(card));
  }, []);

  return (
    <div className="terms-page">
      <section className="services-section">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">
              Terms & <span className="highlight">Conditions</span>
            </h2>
            <p className="section-subtitle">
              Please review our service terms carefully.
            </p>
          </div>

          <div className="row">
            {termsData.map((item, index) => (
              <div
                key={index}
                className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 mb-4"
              >
                <div className="small-term-card">
                  <h6>
                    {index + 1}. {item.title}
                  </h6>
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Terms;
